import { matchesAnyKeyword } from './matchesAnyKeyword.ts';
import { CADENCE_KEYWORDS_BY_CADENCE } from './statusUpdateSignalKeywords.ts';

/** Cadences a status update can follow. */
export type StatusUpdateCadence = 'daily' | 'weekly' | 'biweekly' | 'monthly' | 'quarterly';

/** Classification result; `undefined` when no cadence keyword matches. */
export type StatusUpdateCadenceResult = StatusUpdateCadence | undefined;

/**
 * Order in which cadences are tested. More specific cadences are checked
 * first so that overlapping text resolves deterministically.
 */
const CADENCE_PRECEDENCE: readonly StatusUpdateCadence[] = [
	'quarterly',
	'monthly',
	'biweekly',
	'weekly',
	'daily',
];

/**
 * Classifies the cadence of a status update from text.
 */
export const detectStatusUpdateCadence = (text: string): StatusUpdateCadenceResult => {
	if (!text) {
		return undefined;
	}
	for (const cadence of CADENCE_PRECEDENCE) {
		if (matchesAnyKeyword(text, CADENCE_KEYWORDS_BY_CADENCE[cadence])) {
			return cadence;
		}
	}
	return undefined;
};
